import React from 'react';

import classNames from 'classnames/bind';
import style from './Roles.scss';
const ctx = classNames.bind(style);

const Roles = props => (
  <div className={ctx('roles')}>
    <div className={ctx('roles-title')}>{props.title}</div>
    <div className={ctx('container')}>
      {props.children.map(({ icon, title, description }, idx) => (
        <div className={ctx('role')}>
          <div className={ctx('inner')} key={idx}>
            <div className={ctx('icon')}>
              <img src={icon} />
            </div>
            <div className={ctx('text')}>
              <div className={ctx('title')}>{title}</div>
              <div className={ctx('description')}>{description}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Roles;
